export const tableColumns = [
    { label: "#", width: "100px", rowSpan: 2, color: "#009ed6" },
    { label: "Center Name", width: "200px", rowSpan: 2, color: "#009ed6" },
    { label: "Date", width: "150px", rowSpan: 2, color: "#009ed6" },

    {
        label: "Opening Lead Balance", colSpan: 4, color: "#009ed6",
        subColumns: [
            { key: "opening_pending_follow_up", label: "Pending Follow-Ups", width: "200px", color: "#009ed6" },
            { key: "opening_today_schedule", label: "Today's Follow up Schedule", width: "200px", color: "#009ed6" },
            { key: "opening_pending_till_yesterday", label: "New Leads Before Closing", width: "200px", color: "#009ed6" },
            { key: "opening_new_leads_after_closing", label: "New Leads After Closing", width: "200px", color: "#009ed6" },
        ],
    },
    {
        key: "total_opening_lead_balance", label: "Total Opening Lead Balance", width: "200px", rowSpan: 2, color: "#009ed6"
    },
    {
        label: "Live Calls", colSpan: 4, color: "#009ed6",
        subColumns: [
            { key: "live_ongoing_calls", label: "Ongoing Calls", width: "140px", color: "#009ed6" },
            { key: "live_incoming_calls", label: "Incoming Calls", width: "140px", color: "#009ed6" },
            { key: "live_missed_calls", label: "Missed Calls", width: "140px", color: "#009ed6" },
            { key: "live_rejected_calls", label: "Rejected Calls By Us", width: "160px", color: "#009ed6" },
        ]
    },
    {
        label: "Today Lead Update", colSpan: 5, color: "#009ed6",
        subColumns: [
            { key: "today_new", label: "New", width: "110px", color: "#009ed6" },
            { key: "today_follow_ups", label: "Follow Ups", width: "120px", color: "#009ed6" },
            { key: "today_close", label: "Close", width: "120px", color: "#009ed6" },
            { key: "today_convert_to_opd", label: "Convert To OPD", width: "140px", color: "#009ed6" },
            { key: "today_transfer_to_center", label: "Transfer To Center", width: "160px", color: "#009ed6" },
        ]
    },
    { key: "total_today_lead_update", label: "Total Today Lead Update", width: "180px", rowSpan: 2, color: "#009ed6" },
    {
        label: "Closing Lead Update", colSpan: 2, color: "#009ed6",
        subColumns: [
            { key: "closing_pending_follow_ups", label: "Pending FollowUps", width: "140px", color: "#009ed6" },
            { key: "closing_pending_new_leads", label: "Pending New Leads", width: "140px", color: "#009ed6" },
        ]
    },
    { key: "total_closing_lead_balance", label: "Total Closing Lead Balance", width: "190px", rowSpan: 2, color: "#009ed6" },
    {
        label: "Patients(OPD)", colSpan: 6, color: "#009ed6",
        subColumns: [
            { key: "opd_scheduled", label: "Scheduled", width: "140px", color: "#009ed6" },
            { key: "opd_cancel", label: "Cancel", width: "140px", color: "#009ed6" },
            { key: "opd_finished", label: "Finished", width: "140px", color: "#009ed6" },
            { key: "opd_transfer", label: "Transfer to Center", width: "160px", color: "#009ed6" },

            { key: "opd_treatment", label: "Convert to Treatment", width: "260px", color: "#009ed6" },
            { key: "opd_investigation", label: "Convert to Investigation", width: "270px", color: "#009ed6" },
        ],
    },
    {
        label: "Treatments", colSpan: 11, color: "#009ed6",
        subColumns: [
            { key: "treatment_machines", label: "Number of Machine", width: "160px", color: "#009ed6" },
            { key: "treatment_running", label: "Running Patient", width: "160px", color: "#009ed6" },
            { key: "treatment_added_today", label: "Patient Added Today", width: "160px", color: "#009ed6" },
            { key: "treatment_finished_today", label: "Patient Finish Today", width: "160px", color: "#009ed6" },
            { key: "treatment_net_running", label: "Net Running Patient", width: "160px", color: "#009ed6" },
            { key: "treatment_transferred", label: "Patient Transfer Today", width: "160px", color: "#009ed6" },
            { key: "treatment_net_finished", label: "Net Treatment Finish", width: "160px", color: "#009ed6" },
            { key: "treatment_cui", label: "CUI", width: "160px", color: "#009ed6" },
            { key: "treatment_schedule_based", label: "As Per Schedule", width: "160px", color: "#009ed6" },
            { key: "treatment_crm_based", label: "As Per CRM", width: "160px", color: "#009ed6" },
            { key: "treatment_compression_based", label: "As Per Compression", width: "160px", color: "#009ed6" },
        ]
    },
];
